// platform/* 페이지 번역
const platform = {
  layout: {
    menu: {
      companies: '회사 관리',
      users: '전체 사용자',
      status: '시스템 현황',
      licenses: '라이선스 관리',
    },
  },
  companies: {
    stats: {
      total: '전체 회사',
      active: '활성 회사',
      users: '전체 사용자',
      equipments: '전체 설비',
    },
    listTitle: '회사 목록',
    addBtn: '회사 등록',
    loading: '로딩 중...',
    empty: '등록된 회사가 없습니다.',
    col: {
      code: '회사코드',
      name: '회사명',
      schema: '스키마',
      ceo: '대표자',
      users: '사용자',
      plan: '플랜',
      status: '상태',
      createdAt: '등록일',
      actions: '관리',
    },
    usersSuffix: '{n}명',
    actions: {
      delete: '삭제',
    },
    confirmDelete: '정말 "{name}" 회사를 삭제하시겠습니까?\n\n삭제 시 다음 데이터가 모두 삭제됩니다:\n- 회사 정보\n- 모든 사용자 계정\n- 테넌트 스키마 및 데이터\n\n이 작업은 되돌릴 수 없습니다.',
    alertDeleted: '"{name}" 회사가 삭제되었습니다.',
    alertDeleteFail: '삭제 실패: {error}',
    alertDeleteError: '회사 삭제 중 오류가 발생했습니다.',
    alertUnknownError: '알 수 없는 오류',
  },
  companyRegister: {
    title: '회사 등록',
    sectionBasic: '기본 정보',
    sectionContact: '연락처 정보',
    sectionSubscription: '구독 정보',
    sectionAdmin: '관리자 계정',
    adminDescription: '회사 등록 시 함께 생성될 관리자 계정 정보입니다.',
    fields: {
      name: '회사명',
      code: '회사코드',
      schema: '스키마명',
      ceo: '대표자명',
      businessNumber: '사업자등록번호',
      contactEmail: '대표 이메일',
      contactPhone: '대표 연락처',
      address: '주소',
      plan: '구독 플랜',
      status: '구독 상태',
      maxUsers: '최대 사용자 수',
      maxEquipments: '최대 설비 수',
      adminUsername: '관리자 아이디 (이메일)',
      adminEmail: '관리자 이메일',
      adminPassword: '비밀번호',
      adminPasswordConfirm: '비밀번호 확인',
    },
    placeholder: {
      name: '회사명을 입력하세요',
      code: '영문 소문자, 숫자만 입력 (예: company1)',
      schema: '회사코드 입력 시 자동 생성',
      ceo: '대표자명을 입력하세요',
      businessNumber: '숫자만 입력',
      contactEmail: 'company@example.com',
      contactPhone: '02-1234-5678',
      address: '회사 주소를 입력하세요',
      adminUsername: 'admin@example.com',
      adminEmail: 'admin@example.com',
      adminPassword: '8자 이상 입력',
      adminPasswordConfirm: '비밀번호를 다시 입력',
    },
    schemaHint: '회사코드 기반으로 자동 생성됩니다',
    plan: {
      basic: 'Basic',
      standard: 'Standard',
      premium: 'Premium',
      enterprise: 'Enterprise',
    },
    status: {
      trial: 'Trial (체험)',
      active: 'Active (활성)',
      suspended: 'Suspended (중지)',
    },
    cancel: '취소',
    submit: '회사 등록',
    submitting: '등록 중...',
    success: '회사가 성공적으로 등록되었습니다.',
    fail: '회사 등록에 실패했습니다.',
    error: '회사 등록 중 오류가 발생했습니다.',
    validation: {
      nameRequired: '회사명을 입력해주세요',
      codeRequired: '회사코드를 입력해주세요',
      codeLength: '회사코드는 2~20자여야 합니다',
      ceoRequired: '대표자명을 입력해주세요',
      businessNumberInvalid: '사업자번호 형식이 올바르지 않습니다 (예: 123-45-67890)',
      contactEmailInvalid: '이메일 형식이 올바르지 않습니다',
      contactPhoneInvalid: '연락처 형식이 올바르지 않습니다 (예: 02-1234-5678)',
      maxUsersMin: '최소 1명 이상이어야 합니다',
      maxEquipmentsMin: '최소 1대 이상이어야 합니다',
      adminUsernameRequired: '관리자 아이디(이메일)를 입력해주세요',
      adminEmailInvalid: '이메일 형식이 올바르지 않습니다',
      adminEmailRequired: '관리자 이메일을 입력해주세요',
      adminPasswordRequired: '비밀번호를 입력해주세요',
      adminPasswordLength: '비밀번호는 8자 이상이어야 합니다',
      adminPasswordMismatch: '비밀번호가 일치하지 않습니다',
    },
  },
  globalUsers: {
    stats: {
      total: '전체 사용자',
      admin: '관리자',
      active: '활성 사용자',
    },
    listTitle: '사용자 목록',
    filterAllCompanies: '전체 회사',
    loading: '로딩 중...',
    empty: '사용자가 없습니다.',
    col: {
      name: '사용자명',
      email: '이메일',
      company: '소속 회사',
      role: '권한',
      status: '상태',
      lastLogin: '최근 로그인',
    },
    role: {
      superAdmin: '슈퍼관리자',
      admin: '관리자',
      user: '일반사용자',
    },
    statusActive: '활성',
    statusInactive: '비활성',
  },
  systemStatus: {
    stats: {
      totalCompanies: '전체 회사',
      activeCompanies: '활성 회사',
      totalUsers: '전체 사용자',
      activeUsers: '활성 사용자',
    },
    serviceStatus: '서비스 상태',
    refresh: '새로고침',
    col: {
      service: '서비스',
      status: '상태',
      url: 'URL',
    },
    statusRunning: '실행 중',
    statusError: '오류',
    noStatus: '서버에서 상태를 받지 못했습니다',
    etlTitle: 'ETL 현황',
    etl: {
      lastRun: '마지막 실행',
      status: '상태',
      records: '처리 레코드',
      sync: '동기화 주기',
      success: '성공',
      noData: '데이터 없음',
      error: '오류',
      recordsSuffix: '{n}건',
    },
    dbTitle: '데이터베이스 현황',
    db: {
      tables: '총 테이블',
      records: '총 레코드',
      size: 'DB 사이즈',
      tablesSuffix: '{n}개',
    },
  },
  licenseManagement: {
    stats: {
      total: '전체 라이선스',
      active: '활성 라이선스',
      expiring: '만료 임박 (30일 이내)',
    },
    listTitle: '라이선스 목록',
    loading: '로딩 중...',
    empty: '라이선스가 없습니다.',
    col: {
      company: '회사명',
      type: '라이선스 유형',
      users: '사용자',
      equipments: '설비',
      startDate: '시작일',
      endDate: '만료일',
      status: '상태',
    },
    type: {
      enterprise: '엔터프라이즈',
      standard: '스탠다드',
      basic: '베이직',
      trial: '체험판',
    },
    daysRemaining: '{n}일 남음',
    statusActive: '활성',
    statusExpired: '만료',
  },
};

export default platform;
